import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79c61993"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text--right" }
const _hoisted_2 = {
  key: 0,
  class: "text--center mt-1"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "text--center"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "login primary__color__text" }
const _hoisted_7 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_8 = {
  key: 1,
  class: "text--center"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_10 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_11 = {
  key: 2,
  class: "text--center"
}
const _hoisted_12 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    size: "250px",
    modelValue: _ctx.drawer,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event)),
    withHeader: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "full-height-drawer scroll",
        style: _normalizeStyle(_ctx.getDrawerColor())
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isLogged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_el_avatar, {
                  class: "pointer-link",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('AccountSettings'))),
                  size: 80,
                  src: _ctx.participantPhoto
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.eventData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventFeatures(), (feature, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "drawer-section"
                  }, [
                    _createVNode(_component_el_button, {
                      text: "",
                      class: "section primary__color__text",
                      onClick: ($event: any) => (_ctx.goTo(feature.to))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(feature.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isLogged && _ctx.isOnlineRegisterActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('Register'))),
                class: "primary__dark__color__button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                ]),
                _: 1
              }),
              (!_ctx.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("drawer.alreadyAccount")), 1),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('Login'))),
                      class: "login__bt mb-2 secondary__color__button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("login.loginTitle")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.signOut,
                      class: "mb-2 secondary__color__button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("login.logout")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
            ]))
          : (_ctx.isOnlineRegisterActive || _ctx.isLogged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.isLogged)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('Checkout'))),
                        type: "primary",
                        class: "primary__dark__color__button",
                        disabled: !_ctx.statusPaid
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("drawer.checkout")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('Register'))),
                        class: "secondary__color__button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                        ]),
                        _: 1
                      })
                    ])),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.signOut,
                  class: "mb-2 secondary__color__button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("login.logout")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_ctx.optionalOnlineRegisterURL !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToOptionalURL())),
                      class: "secondary__color__button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}